// @ts-check

import { fromTable } from "../insforgeDB";

/**
 * Table-access surface. Re-exports through `insforgeDB.fromTable` so the
 * `is_staging` isolation behaviour (auto-tagging inserts/upserts and
 * auto-filtering selects/updates/deletes) continues to apply.
 *
 * Pages and services should call `db.from(table)` (or the named `from`
 * export) instead of `fromTable` directly. Once every caller has moved
 * over, `insforgeDB.js` can be folded into this module.
 *
 * The returned builder proxies the SDK's chainable methods unchanged
 * (`select`, `insert`, `upsert`, `update`, `delete`, plus the chain
 * helpers `eq`, `order`, `limit`, `single`, `in`, `gt`, `ilike`, …).
 *
 * @typedef {Object} DbBuilder
 * @property {(...args: any[]) => any} select
 * @property {(rows: object | object[]) => any} insert
 * @property {(rows: object | object[], opts?: object) => any} upsert
 * @property {(patch: object) => any} update
 * @property {() => any} delete
 *
 * @typedef {Object} DbSurface
 * @property {(table: string) => DbBuilder} from
 */

export function from(table) {
  return fromTable(table);
}

/** @type {DbSurface} */
export const db = { from };
